import * as Yup from "yup";

export const categoryFinancialSchema = Yup.object().shape({
  description: Yup.string()
    .trim()
    .required("Por favor, insira a descrição.")
    .max(255, "Use no máximo 255 caracteres."),
  note: Yup.string().trim().max(255, "Use no máximo 255 caracteres."),
  is_active: Yup.boolean(),
});
